import _ from "lodash";

const UploadFilesReducer = (state, action) => ({
  ...state,
  files: _.concat(...state.files, action.payload)
});

export default UploadFilesReducer;
